<template>
  <fragment>
    <mc-app-header title="Challenges" has-search resource-state="challenges">
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/challenges/new"
            >Add New</router-link
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="challenges section">
        <mc-paginated-list
          v-slot="{ items: challengesList }"
          has-search
          resource-state="challenges"
        >
          <div v-if="challengesList.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No challenges available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="(challenge, index) in challengesList"
              :key="index"
              class="challenges__item box"
            >
              <div class="challenges__item-desc">
                <div class="challenges__item-title">{{ challenge.name }}</div>
                <b-field grouped group-multiline>
                  <div
                    v-if="
                      challenge.relatedTopicNames &&
                        challenge.relatedTopicNames.length
                    "
                    class="control"
                  >
                    <b-taglist>
                      <b-tag
                        v-for="topicName in challenge.relatedTopicNames"
                        :key="topicName"
                      >
                        {{ topicName }}
                      </b-tag>
                    </b-taglist>
                  </div>
                  <div class="control">
                    <b-taglist v-if="!!challenge.version" attached>
                      <b-tag type="is-dark">version</b-tag>
                      <b-tag type="is-info">
                        {{ challenge.version }}
                      </b-tag>
                    </b-taglist>
                  </div>
                  <div class="control">
                    <b-taglist>
                      <b-tag v-if="challenge.admin" type="is-info"
                        >adminPublished</b-tag
                      >
                    </b-taglist>
                  </div>
                </b-field>
              </div>
              <router-link
                class="button is-link is-small"
                :to="`/challenges/${challenge.id}/attempts`"
                >Challenge Attempts</router-link
              >
              <router-link
                class="button is-link is-small"
                :to="`/challenges/edit/${challenge.id}`"
                >Edit</router-link
              >
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
export default {
  data() {
    return {
      publishLevelColors: {
        user: 'is-success',
        admin: 'is-warning',
        none: 'is-danger'
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.challenges {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title {
    margin-bottom: 0.5rem;
  }

  .button:not(:last-child) {
    margin-right: 0.5rem;
  }
}
</style>
